import React from "react"
import { List } from "@cd2/components"
import { LabelInfo } from "../Components/LabelInfo"
import { IRecord } from "../types/schema"
import { HoverResourceLoader } from "./HoverResourceLoader"
import { buildRoute, eRoutes } from "../routes"

type IPurchaseOrder = IRecord<
  "purchase_orders",
  "identifier" | "sage_export_status" | "sage_order_number" | "processed"
>

interface IProps {
  id?: string
  initialData?: IPurchaseOrder
  renderInlineLink?: "block" | "inline"
}

export function HoverPurchaseOrderLoader({ id, initialData, renderInlineLink }: IProps) {
  const skeem = window.skeem

  async function loadData() {
    const purchase_order = await skeem.fetchOne<IPurchaseOrder>({
      purchase_orders: {
        attributes: ["identifier", "sage_export_status", "sage_order_number", "processed"],
        filter: { matches: { id } },
      },
    })
    return purchase_order
  }

  if (!id) {
    return <span>-</span>
  }

  return (
    <HoverResourceLoader
      reloadKey={id}
      loadData={loadData}
      initialData={initialData}
      viewLink={purchase_order =>
        buildRoute(eRoutes["/purchase-orders/:id"], { id: purchase_order.id })
      }
      resourceName="PurchaseOrder"
      renderHoverContentTitle={record => record.identifier}
      renderInlineLink={renderInlineLink}
      renderHoverContent={record => (
        <div>
          <List>
            <LabelInfo labelWidth={80} label="Identifier" value={record.identifier} inline />
            <LabelInfo
              labelWidth={80}
              label="Sage Order Number"
              value={record?.sage_order_number || "Not Exported"}
              inline
            />
          </List>
        </div>
      )}
      renderTarget={record => <span>{record.identifier}</span>}
    />
  )
}
